import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 1.5rem 0;
  align-items: center;
  text-align: center;
  flex-direction: column;
  justify-content: center;
`;
